'use strict';

/* Filters */

var cacheCleanerFilters = angular.module('cacheCleanerFilters', []);


// WEBPACK FOOTER //
// ./scripts/filters.js